import React from "react";
import { Link } from "react-router-dom";
import { Reveal, Label, SectionTitle } from "@/components/Reveal";
import { Gem, Target, Heart, Award, Sparkles, Users } from "lucide-react";
import { IMAGES } from "@/data/content";

const PageHero = ({ label, title, sub, img }) => (
  <section className="relative pt-40 pb-20 overflow-hidden">
    <div className="absolute inset-0"><img src={img} alt="" className="w-full h-full object-cover opacity-25" /><div className="absolute inset-0 bg-gradient-to-b from-midnight/70 to-midnight" /></div>
    <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
      <Label>{label}</Label>
      <h1 className="text-5xl sm:text-6xl lg:text-7xl tracking-tighter mt-5">{title}</h1>
      {sub && <p className="text-lg text-white/70 mt-6 max-w-2xl mx-auto leading-relaxed">{sub}</p>}
    </div>
  </section>
);

const VALUES = [
  { icon: Gem, title: "Our Vision", text: "To be Bangalore's most trusted luxury beauty destination and the launchpad for the next generation of world-class beauty professionals." },
  { icon: Target, title: "Our Mission", text: "To deliver extraordinary transformations through artistry, hygiene and heart — while empowering students with real, career-ready skills." },
  { icon: Heart, title: "Core Values", text: "Excellence, integrity, hygiene, creativity and genuine care for every client and student who walks through our doors." },
];

const WHY = [
  { icon: Award, title: "Certified Experts", text: "Award-winning stylists & educators" },
  { icon: Sparkles, title: "Premium Products", text: "Only international luxury brands" },
  { icon: Users, title: "5000+ Clients", text: "Trusted across Bangalore" },
  { icon: Gem, title: "Luxury Ambience", text: "5-star salon experience" },
];

export default function About() {
  return (
    <>
      <PageHero label="Our Story" title="Where Passion Meets Perfection" sub="Spunky Scissors began with a single belief — that beauty is an art, and everyone deserves to feel extraordinary." img={IMAGES.salon1} />

      <section className="py-20 max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal><div className="relative aspect-[4/5] rounded-lg overflow-hidden border border-gold/20"><img src={IMAGES.bridal2} alt="Founder" className="w-full h-full object-cover" /></div></Reveal>
        <Reveal delay={0.1}>
          <Label>The Journey</Label>
          <h2 className="text-4xl sm:text-5xl tracking-tight mt-4">A Salon &amp; Academy Built on Artistry</h2>
          <p className="text-white/70 mt-5 leading-relaxed">What started as a boutique salon in HRBR Layout has grown into one of Bangalore's most loved unisex salons and beauty academies. Our salon journey is defined by thousands of transformations, while our academy journey has trained over a thousand professionals now flourishing across the industry.</p>
          <p className="text-white/70 mt-4 leading-relaxed">Our founder's vision was simple yet bold — combine world-class artistry with genuine education, so beauty becomes both a luxury experience and a life-changing career.</p>
        </Reveal>
      </section>

      <section className="py-20 bg-royal/20 border-y border-gold/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <SectionTitle label="What Drives Us" title="Vision, Mission &amp; Values" />
          <div className="grid md:grid-cols-3 gap-6">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.1}>
                <div className="glass rounded-lg p-8 h-full transition-colors duration-500">
                  <v.icon className="text-gold" size={30} />
                  <h3 className="text-2xl mt-5">{v.title}</h3>
                  <p className="text-white/70 mt-3 leading-relaxed text-sm">{v.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTitle label="The Difference" title="Why Choose Spunky Scissors" />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {WHY.map((w, i) => (
            <Reveal key={w.title} delay={i * 0.08}>
              <div className="glass rounded-lg p-7 text-center h-full transition-colors duration-500">
                <w.icon className="text-gold mx-auto" size={28} />
                <h4 className="text-lg mt-4">{w.title}</h4>
                <p className="text-white/60 text-xs mt-2">{w.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="text-center mt-14"><Link to="/book" className="btn-gold" data-testid="about-book">Experience It Yourself</Link></div>
      </section>
    </>
  );
}
